export default __webpack_public_path__ + "static/slide-06-e3cf169928596d6e3595c11d48eff548.jpg";